var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram-one (instagram)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.2127 9.40555C8.98313 9.40555 10.4183 8.0019 10.4183 6.2704C10.4183 4.53891 8.98313 3.13525 7.2127 3.13525C5.44227 3.13525 4.00706 4.53891 4.00706 6.2704C4.00706 8.0019 5.44227 9.40555 7.2127 9.40555Z",
    stroke: "#AC7953",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4183 14.1082H4.00706V33.7028H10.4183V14.1082Z",
    stroke: "#AC7953",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.8296 21.5541V33.7028H22.4395V22.7298C22.4395 20.7703 23.6416 19.2028 25.6452 19.2028C27.6487 19.2028 28.8508 21.1622 28.8508 22.7298V33.7028H34.4607V21.5541C34.4607 19.2028 31.6558 14.1082 25.6452 14.1082C19.6346 14.1082 16.8296 19.2028 16.8296 21.5541Z",
    stroke: "#AC7953",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.28bb79872108cb390225e6ef31f93ac3.svg";
export { ForwardRef as ReactComponent };